import React, { useState } from "react";
import Header from "../Header";
import FunderSidebar from "./FunderSidebar";
import { CallSwitcher } from "./FunderUI";
import { getCalls, getActiveCallId, setActiveCallId, getCall } from "../../service/FunderPortalService";

/**
 * Page shell for every funder-portal page. Renders the DeepThought chrome
 * (sidebar + header) around a slim call-context bar with the call switcher.
 *
 * Access: the portal is intentionally public — it opens from a shared link
 * (e.g. /funder) with no login required. It renders only demo data
 * (constants/funderDemoData.js) and makes no backend calls, so no real data is
 * exposed. Entry points are the public /funders overview page (FunderLanding.js,
 * whose CTAs route in here) and the admin/funder sidebar item; when logged out
 * the header drops the user menu + notifications bell. (The FeatureGate flag is
 * a separate kill-switch at the route level.)
 *
 * `children` is a render function `(callId, call) => ReactNode` so the switcher
 * can re-scope the page without React Context.
 */
export default function FunderShell({ activePage, children }) {
    const [callId, setCallId] = useState(getActiveCallId());

    const calls = getCalls();
    const call = getCall(callId);

    const onChangeCall = (id) => {
        setActiveCallId(id);
        setCallId(id);
    };

    return (
        <div className="home-layout">
            <FunderSidebar activePage={activePage} />
            <main className="home-main">
                <Header />
                <div className="home-content">
                    <div className="funder-topbar">
                        <div className="funder-topbar-context">
                            <span className="funder-topbar-funder">{call.funder}</span>
                            <span className="funder-topbar-sep">·</span>
                            <span>{call.scheme}</span>
                            <span className={`funder-call-status funder-call-status-${call.status}`}>
                                {call.status === "active" ? "Active" : "Closed"}
                            </span>
                        </div>
                        <CallSwitcher calls={calls} callId={callId} onChange={onChangeCall} />
                    </div>
                    {typeof children === "function" ? children(callId, call) : children}
                </div>
            </main>
        </div>
    );
}
